package com.trevorwiebe.timesheet.payPeriod.presentation

import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.trevorwiebe.timesheet.core.domain.Util.toFriendlyDate
import com.trevorwiebe.timesheet.core.presentation.TopBar
import com.trevorwiebe.timesheet.core.presentation.common.BackIcon
import com.trevorwiebe.timesheet.core.presentation.common.ResponsiveContent
import com.trevorwiebe.timesheet.core.presentation.common.botPadding
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.ChipItem
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.UiTimeSheet
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.color
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

@Composable
fun PayPeriodScreen(
    userId: String? = null,
    title: String = "Pay Periods",
    onBack: (() -> Unit)? = null,
    viewModel: PayPeriodViewModel = koinViewModel { parametersOf(userId) },
    onPayPeriodClick: (startTime: String, endTime: String, timesheetId: String) -> Unit,
) {

    val staticState by viewModel.staticPayPeriodState.collectAsState()

    Scaffold(
        topBar = {
            if (onBack != null) {
                TopBar(title = title, backIcon = { BackIcon() }, onBack = onBack)
            } else {
                TopBar(title = title)
            }
        }
    ) {
        ResponsiveContent(modifier = Modifier.padding(it)) {
            LazyColumn(
                reverseLayout = true,
                modifier = Modifier.fillMaxSize()
            ) {
                item {
                    Spacer(Modifier.height(botPadding()))
                }
                items(staticState.timeSheets) { timeSheet ->
                    PayPeriodItem(timeSheet) { startTime, endTime, timeSheetId ->
                        onPayPeriodClick(startTime, endTime, timeSheetId)
                    }
                }
            }
        }
    }
}

@Composable
private fun PayPeriodItem(
    uitTimeSheet: UiTimeSheet,
    onPayPeriodClick: (startTime: String, endTime: String, timesheetId: String) -> Unit,
){

    val timeSheet = uitTimeSheet.timeSheet
    val startDateString = timeSheet.payPeriodStart.toString()
    val endDateString = timeSheet.payPeriodEnd.toString()

    val startDate = toFriendlyDate(timeSheet.payPeriodStart)
    val endDate = toFriendlyDate(timeSheet.payPeriodEnd)

    val rowScrollState = rememberScrollState()

    Card(
        modifier = Modifier.fillMaxWidth().padding(8.dp),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surface
        )
    ){
        Column(
            modifier = Modifier.fillMaxWidth().clickable {
                onPayPeriodClick(
                    startDateString,
                    endDateString,
                    timeSheet.id
                )
            }
        ){

            val payPeriodString = "$startDate - $endDate"

            Text(
                modifier = Modifier.padding(8.dp),
                text = payPeriodString,
                fontWeight = FontWeight.Bold,
                fontSize = 18.sp,
                color = MaterialTheme.colorScheme.secondary
            )
            Row(
                modifier = Modifier
                    .padding(top = 8.dp, bottom = 8.dp)
                    .fillMaxWidth().horizontalScroll(rowScrollState)
            ) {
                Spacer(modifier = Modifier.width(4.dp))
                uitTimeSheet.status.forEach { status ->
                    ChipItem(status.title, status.color)
                }
                Spacer(modifier = Modifier.width(4.dp))
            }
        }
    }
}